import {
  type NewsItem,
  type NewsItemOld,
} from 'hb-react/frontoffice/apps/NewsIndex/utils/types';
import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';

interface NewsResponseOld {
  news: Array<NewsItemOld>;
  totalItems: number;
}

interface NewsResponseNew {
  data: Array<NewsItem>;
  total: number;
}

export const fetchNews = (
  url: string,
  signal: AbortSignal,
  params: unknown = {},
) =>
  axios
    .get<NewsResponseNew | NewsResponseOld>(url, { params, signal })
    .then(({ data }) => ({
      items: 'news' in data ? data.news : data.data,
      totalItems: 'totalItems' in data ? data.totalItems : data.total,
    }));
